import React from "react";

import Header from "./header";
import Footer from "./footer";

import "../assets/sass/app.scss";
import * as styles from "../assets/sass/modules/_layout.module.scss";

const Layout = ({ children }) => {
  return (
    <main>
      <Header />
      <div className={styles.childrenWrapper}>{children}</div>
      <Footer />
    </main>
  );
};

export default Layout;
